












































































import {Vue,Component} from "vue-property-decorator";
import RestcommNumbers from "@/consoleapi/api/restcomm/numbers";
import CreateIncomingPhoneNumberModal from "@/components/numbers/CreateIncomingPhoneNumberModal.vue";

@Component({
    components:{
        CreateIncomingPhoneNumberModal
    }
})
export default class NumberList extends Vue {
  private numbers = {};

  private createModal = false;


  private deleteModal = false;


  private searchNumber = null;


  private activeNumber = '';


  private activeNumberSid = '';

  showCreateModal() {
    this.createModal = true;
  }

  closeCreateModal() {
    this.createModal = false;
    this.getNumbers();
  }

  showDeleteModal(number: string, sid: string) {
    this.activeNumber = number;
    this.activeNumberSid = sid;
    this.deleteModal = true;
  }

  closeDeleteModal() {
    this.activeNumber = '';
    this.activeNumberSid = '';
    this.deleteModal = false;
    this.getNumbers();
  }

  getNumbers(number: string | null = null) {
    const query = number ? '?number=' + number : '';
    const ipn = new RestcommNumbers();
    ipn.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    ipn.get(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)),query)
        .then(response => {
          console.log(response);
          this.numbers = response.data.incomingPhoneNumbers;
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  /**
   *
   */
  deleteNumber() {
    const ipn = new RestcommNumbers();
    ipn.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    ipn.delete(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)), this.activeNumberSid)
        .then(response => {
          console.log(response);
          this.closeDeleteModal();
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  mounted() {
    this.getNumbers();
  }
}
